import * as types from '../constants/actionTypes';
import * as dsaTypes from '../constants/dsaTypes';
import initialState from './initialState';

import * as steps from '../constants/createDSAWorkflowSteps';

export default function createDSAWorkflowReducer(state = initialState.createDSAWorkflow, action) {
  switch (action.type) {
    case types.BEGIN_CREATE_DSA_WORKFLOW:
      return {
        open: true,
        step: steps.SELECT_DSA_TYPE,
        clone: false,
        dsaType: action.dsaType
      };
    case types.BEGIN_CLONE_DSA_WORKFLOW:
      return {
        open: true,
        step: steps.SELECT_LINKED_OPPORTUNITIES,
        dsa: action.dsa,
        dsaType: action.dsa.dsaType,
        clone: true
      };
    case types.BEGIN_CONVERT_DSA_WORKFLOW:
      return {
        open: true,
        step: steps.CONFIRM_CONVERSION,
        dsa: action.dsa,
        dsaType: dsaTypes.FULL_DSA,
        clone: true,
        convert: true
      };
    case types.CONFIRM_BEGIN_CONVERT_DSA_WORKFLOW:
      return {
        open: true,
        step: steps.SELECT_DSA_TYPE,
        dsa: state.dsa,
        dsaType: dsaTypes.FULL_DSA,
        clone: true,
        convert: true
      };
    case types.BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW:
      return {
        open: true,
        step: steps.CONFIRM_CUSTOMER_CONVERSION,
        dsa: action.dsa,
        dsaType: action.dsa.dsaType,
        clone: false,
        convert: false, // convert actually only means convert a new customer DSA to a normal DSA
        convertCustomer: true, // this means convert from a test assmt to a customer/linked assmt
        endWithPpt: true
      };
    case types.CONFIRM_BEGIN_CONVERT_CUSTOMER_DSA_WORKFLOW:
      return {
        open: true,
        step: steps.SELECT_LINKED_OPPORTUNITIES,
        dsa: action.dsa,
        dsaType: action.dsa.dsaType,
        clone: false,
        convert: false,
        convertCustomer: true,
        endWithPpt: state.endWithPpt ? state.endWithPpt : false,
        opportunities: action.opportunities,
        availableOpportunities: action.availableOpportunities,
        hasAvailableOpportunities: action.hasAvailableOpportunities
      };
    case types.PROMPT_FOR_NEW_DSA_LINKED_OPPORTUNITIES:
      return {
        open: true,
        step: steps.SELECT_LINKED_OPPORTUNITIES,
        clone: state.clone,
        convert: state.convert,
        dsa: state.dsa,
        dsaType: state.dsaType
      };
    case types.CANCEL_CREATE_DSA_WORKFLOW:
      return {
        open: false,
        step: null
      };
    case types.CREATE_DSA:
      return {
        ...state,
        loading: true
      };
    case types.CREATE_DSA_SUCCESS:
      return {
        open: false,
        step: null
      };
    case types.CLONE_DSA:
      return {
        ...state,
        loading: true
      };
    case types.CLONE_DSA_SUCCESS:
      return {
        open: false,
        step: null
      };
    case types.CONVERT_CUSTOMER_DSA:
      return {
        ...state,
        loading: true
      };
    case types.CONVERT_CUSTOMER_DSA_SUCCESS:
      return {
        open: false,
        step: null
      };
    case types.SALESFORCE_SYNC_ERROR:
      return {
        open: true,
        step: steps.SELECT_LINKED_OPPORTUNITIES,
        clone: state.clone,
        dsa: action.dsa,
        dsaType: state.dsaType,
        salesforceSyncError: true
      };
    case types.CONFIRM_SALESFORCE_SYNC_ERROR:
      return {
        open: false,
        step: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/createDSAWorkflowReducer.js